import { useCallback } from 'react';
import { addMarker } from 'shared/utils/maps/add-marker.ts';
import { EMapMarkerType } from 'types/map';
import type { IGetMarketsParams, IUseSetWarehousesMarkersOptions } from 'components/map/map-container/hooks/types.ts';
import { useSetMarkers } from 'components/map/map-container/hooks/use-set-markers.ts';

export const useSetWarehousesMarkers = ({ map, warehouses }: IUseSetWarehousesMarkersOptions) => {
  const getMarkers = useCallback(
    ({ markersRef }: IGetMarketsParams) => {
      if (!map || !warehouses) {
        return;
      }

      warehouses.forEach((warehouse) => {
        if (warehouse.lat && warehouse.lng && !warehouse.deprecated) {
          const marker = addMarker({
            type: warehouse.internal ? EMapMarkerType.WAREHOUSE : EMapMarkerType.EXTERNAL_WAREHOUSE,
            map,
            position: {
              lat: warehouse.lat,
              lng: warehouse.lng,
            },
            title: warehouse.name,
          });

          markersRef.current.push(marker);
        }
      });
    },
    [map, warehouses],
  );

  useSetMarkers({ map, getMarkers });
};
